import React from "react";
import { Controller } from "react-hook-form";
import ValidationErrorText from "./ValidationErrorText";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const ValidationController = ({
  control,
  name,
  validationConfig,
  renderer,
  errors,
  ...rest
}) => {
  const { t } = useTranslation();
  return (
    <ControllerWrapper {...rest}>
      <Controller
        name={name}
        control={control}
        rules={validationConfig}
        render={(props) => renderer(props)}
      />
      {errors?.[name] && (
        <ValidationErrorText
          text={t(errors[name]?.message || t("fieldRequired"))}
        />
      )}
    </ControllerWrapper>
  );
};

export default ValidationController;

const ControllerWrapper = styled.div`
  .preview-box {
    position: relative;
    width: 100%;
    height: 80px;
    z-index: 999;

    .default-icon.delete-icon {
      svg:hover {
        [stroke] {
          stroke: var(--redColor);
        }
      }
    }
  }

  .preview-video {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }

  .preview-img {
    width: 230px;
    height: 80px;
    object-fit: cover;
  }
  .job-upload-preview-img {
     width: 230px;
    height: 80px;
    border-radius: 10px;
  }
  .job-upload-preview-img span {
    width: 100%;
    height: 100%;
    display: flex !important;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
  }
  .job-upload-preview-img span img {
    max-width: 100%;
    max-height: 100%;
    border-radius: 10px;
  }
`;
